import { CourseStructureInternal } from "./CourseStructureInternal";

export class CourseStructureResponse {
  constructor() {
    this.id = "";
  }
  public id: string;
  public structure: Array<CourseStructureInternal> | undefined;
}
